var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[_c('todo-list',{attrs:{"value":_vm.value,"todo-building":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }